import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    StatusComponent,
} from "../../../common/component/Index";
import { Link } from 'react-router-dom';
import i18n from "../../../../../constants/initLng";
import { PATHS, TICKET, DETAIL_ACTIONS, DATE_TIME_FORMAT } from "../../../../../constants/Define";
import { Descriptions } from 'antd';
import { isEqual, get, find, toArray } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Ticket from '../../../../../models/Ticket';
import Wrapper from './../../../common/component/Wrapper';
import Input from './../../../common/component/Input';

import './MyTickets.less';
import { getLocaleFullName } from '../../../../../utils/commonUtils';
import Span from '../../../common/component/Span';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import TextArea from '../../../common/component/TextArea';
import MyTicketBoard from '../../../modules/MyTicketBoard';
import Modal from '../../../common/component/Modal';
import TicketDetail from '../TicketDetail/TicketDetail';

const defaultState = {
};

const timeout = 5 * 60 * 1000; // 5min;

export default class MyTickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            ticketDetail: undefined,
        };
        this.ticketDetailRef = React.createRef();
        this.refreshInterVal = undefined;
    }

    componentDidMount() {
        this.props.getMyTickets();
        if(!this.refreshInterVal){
            this.refreshInterVal = setInterval(() => this.props.getMyTickets({noLoading: true}), timeout);
        }
    }

    componentWillUnmount(){
        if(this.refreshInterVal){
            clearInterval(this.refreshInterVal);
        }
    }

    render() {
        const { t, ticketState } = this.props;
        const { isFetching, myTickets } = ticketState;
        return (
            <LoadingComponent spinning={isFetching}>
                <PageListComponent className="ticket-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'tickets'}
                        titleHeader={
                            Func.capitalizeFirstLetter((`${t('item.ticket.myTickets')}`.toLowerCase()))
                        }

                    />
                    <Wrapper>
                        <MyTicketBoard
                            tickets={myTickets}
                            onClickTicket={this.onClickTicket}
                        />
                    </Wrapper>
                </PageListComponent>
                {this.renderTicketDetailModal()}
            </LoadingComponent>
        );
    }

    renderTicketDetailModal() {
        const { t, ticketState, userState } = this.props;
        const { ticketDetail } = this.state;
        return (
            <Modal
                bodyStyle={{ padding: '0px 15px' }}
                width={900}
                title={`${t(`action.update`)} ${t(`item.ticket.title`).toLowerCase()}`}
                visible={!!ticketDetail}
                onOk={() => this.onUpdateTicket()}
                okText={t(`action.update`)}
                onCancel={this.closeTicketDetail}
                cancelText={t(`action.cancel`)}
            >
                {ticketDetail ?
                    <TicketDetail t={t} ref={this.ticketDetailRef}
                        ticketId={ticketDetail.id}
                        isMyTicket={true}
                        ticketState={ticketState}
                        userState={userState}
                        onUpdateTicket={this.onUpdateTicket}
                        getMyTicketDetail={this.props.getMyTicketDetail}
                        setMyTicketDetail={this.props.setMyTicketDetail}
                        updateMyTicket={this.props.updateMyTicket}
                        getCSUsers={this.props.getCSUsers}
                    />
                    : <Wrapper style={{ height: 500 }}></Wrapper>
                }
            </Modal>
        )
    }

    onUpdateTicket = (ticket) => {
        if (this.ticketDetailRef.current && !ticket) {
            this.ticketDetailRef.current.onSubmit();
        }
        if (ticket) {
            this.closeTicketDetail();
        }
    }

    closeTicketDetail = () => {
        this.setState({ ticketDetail: undefined })
        if (this.ticketDetailRef.current) {
            this.ticketDetailRef.current.validate(true);
        }
    }

    onClickTicket = (ticket) => {
        this.setState({ ticketDetail: ticket })
    }

}

MyTickets.defaultProps = {

}
